import { Div } from "../../Div";
import { SimpleListItem } from "./SimpleListItem";

export class SimpleItemList extends Div {
    protected createItem(data: string) {
        return new SimpleListItem(data);
    }

    protected createSelf() {
        super.createSelf();
        this.addClass("sl");
        const tdata = this.get("d");
        tdata.forEach((item: any) => {
            this.appendChild(this.createItem(item));
        });
    }
}
